/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResponseDownloadUrl
 */
export interface ResponseDownloadUrl {
    /**
     * 
     * @type {string}
     * @memberof ResponseDownloadUrl
     */
    downloadUrl: string;
}

/**
 * Check if a given object implements the ResponseDownloadUrl interface.
 */
export function instanceOfResponseDownloadUrl(value: object): value is ResponseDownloadUrl {
    if (!('downloadUrl' in value) || value['downloadUrl'] === undefined) return false;
    return true;
}

export function ResponseDownloadUrlFromJSON(json: any): ResponseDownloadUrl {
    return ResponseDownloadUrlFromJSONTyped(json, false);
}

export function ResponseDownloadUrlFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseDownloadUrl {
    if (json == null) {
        return json;
    }
    return {
        
        'downloadUrl': json['download_url'],
    };
}

export function ResponseDownloadUrlToJSON(json: any): ResponseDownloadUrl {
    return ResponseDownloadUrlToJSONTyped(json, false);
}

export function ResponseDownloadUrlToJSONTyped(value?: ResponseDownloadUrl | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'download_url': value['downloadUrl'],
    };
}

